import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const generateQrCodeApi = createApi({
  reducerPath: "generateQrCodeApi",
  baseQuery: axiosBaseQuerySpotfinder({
    baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
  }),
  tagTypes: ['generateQrCode'],
  endpoints: builder => ({
    generateQrCode: builder.mutation({
      query: body => {
        return {
          url: `${spotFinder.QRCodeController.generateQRCode}${body.bookingId}/${body.flag}/${body.subBookingId}?height=200&width=200`,
          method: 'GET',
          headers: {Authorization: `Bearer ${body.token}`},
        };
      },
    }),
  }),
});
export const { useGenerateQrCodeMutation } = generateQrCodeApi;
